import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user) return <Navigate to="/admin/blogs" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(username.trim(), password);
      navigate("/admin/blogs");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main
      style={{ background: "#EBEBEB", minHeight: "100vh" }}
      className="flex items-center justify-center px-4"
    >
      <div className="w-full max-w-md">
        <div
          className="w-12 h-12 rounded-2xl flex items-center justify-center mx-auto"
          style={{ background: "var(--agero-orange)", color: "#fff" }}
        >
          <Lock size={20} />
        </div>
        <h1
          className="font-display text-center mt-5"
          style={{ fontSize: 36, letterSpacing: "-0.03em" }}
        >
          Admin login
        </h1>
        <p className="text-center text-neutral-500 text-sm mt-2">
          LinkedIn Lab editor access.
        </p>

        <form
          onSubmit={submit}
          className="mt-8 p-7 rounded-3xl bg-white border border-neutral-200/70"
        >
          <label className="block text-[13px] font-medium text-neutral-600 mb-2">
            Username
          </label>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-4 py-3 rounded-xl bg-neutral-50 border border-neutral-200 focus:outline-none focus:border-[color:var(--agero-orange)] focus:bg-white transition"
            autoFocus
          />

          <label className="block text-[13px] font-medium text-neutral-600 mb-2 mt-4">
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 rounded-xl bg-neutral-50 border border-neutral-200 focus:outline-none focus:border-[color:var(--agero-orange)] focus:bg-white transition"
          />

          {error && (
            <div
              className="mt-3 text-[13px]"
              style={{ color: "var(--agero-orange)" }}
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="mt-6 w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full font-medium transition disabled:opacity-60"
            style={{ background: "#0A0A0A", color: "#fff" }}
          >
            {submitting ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </main>
  );
}
